import React from 'react';
import { Navigate } from 'react-router-dom';
import { useBrand } from './BrandProvider';

/**
 * The vendor's own public pages (calculator, compare, demos, case studies, contact, trial sign-up, and the guest RSVP and
 * room-booking pages) are for visitors to the vendor's site. A client's flavour signs a visitor in instead
 * (`landing.visitor: signin`, backend/modules/flavours/tetcha.yaml): there is nothing for them to read, and nothing the client
 * bought to book or RSVP to. Their address goes to "/", which shows the sign-in form, or where a signed-in person starts.
 * The server still refuses every API behind these pages; this only stops the screens being mounted.
 */
export default function PublicOnly({ children }) {
  const { landing } = useBrand();
  if (landing && landing.visitor === 'signin') return <Navigate to="/" replace />;
  return children;
}
